import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './FooterSection.css';
import companyLogo from '../assets/logo-dzeltens.png';

const FooterSection = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    // If we're not on the home page, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation, then scroll
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer" id="contact">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Company Info */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={companyLogo} alt="SUBmerge Baltic" />
              <span>SUBmerge Baltic</span>
            </div>
            <p className="footer-tagline">
              Pioneering autonomous underwater technology for a safer maritime future.
            </p>
            <div className="footer-social">
              <a
                href="https://www.linkedin.com/company/submergebaltic/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><button type="button" onClick={() => scrollToSection('home')}>Home</button></li>
              <li><button type="button" onClick={() => scrollToSection('about')}>About Us</button></li>
              <li><button type="button" onClick={() => scrollToSection('products')}>Products</button></li>
              <li><button type="button" onClick={() => scrollToSection('gallery')}>Gallery</button></li>
            </ul>
          </div>

          {/* Products */}
          <div className="footer-links">
            <h4>Products</h4>
            <ul>
              <li><button type="button" onClick={() => scrollToSection('products')}>PIKE ROV</button></li>
              <li><button type="button" onClick={() => scrollToSection('products')}>PIKE AUV</button></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-contact">
            <h4>Get In Touch</h4>
            <div className="contact-items">
              <a href="tel:+37127809311" className="contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                </svg>
                <span>+371 27809311</span>
              </a>
              <a href="mailto:letstalk@submergebaltic.com" className="contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <path d="M22 6l-10 7L2 6"/>
                </svg>
                <span>letstalk@submergebaltic.com</span>
              </a>
              <div className="contact-item location">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <span>Riga, Latvia</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>&copy; {currentYear} SUBmerge Baltic. All rights reserved.</p>
          <p className="footer-made">Latvian Deep-Tech Innovation</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
